import { Dispatch, FC, SetStateAction, useState } from 'react';
import { NotificationsMeetingsMidweekAssignments } from './NotificationsMeetingsMidweekAssignments';
import { NotificationsMeetingsMidweekAvUshers } from './NotificationsMeetingsMidweekAvUshers';
import { NotificationsMeetingsMidweekCleaning } from './NotificationsMeetingsMidweekCleaning';
import { notificationTypes } from '@monorepo/helpers';
import { RadioSelector } from 'src/components/_commons';
import { typeNotificationsDoc, typeMeetingsDoc, typeNotificationType, typeUser } from '@monorepo/models';

type propsType = {
    meetingsDoc: typeMeetingsDoc;
    notificationsDoc: typeNotificationsDoc;
    setRefreshCounter: Dispatch<SetStateAction<number>>;
    users: typeUser[];
};

export const NotificationsMeetingsMidweek: FC<propsType> = ({ meetingsDoc, notificationsDoc, setRefreshCounter, users }) => {
    const [radioValue, setRadioValue] = useState<typeNotificationType>('meetings-midweek-assignment');

    return (
        <div>
            <RadioSelector
                additionalKey={'M'}
                buttonWidth={'300px'}
                options={notificationTypes.filter(nt => nt.isMidweekMeeting)}
                radioValue={radioValue}
                setRadioValue={setRadioValue}
            />
            {radioValue === 'meetings-midweek-assignment' &&
                <NotificationsMeetingsMidweekAssignments
                    meetingsDoc={meetingsDoc}
                    notificationsDoc={notificationsDoc}
                    setRefreshCounter={setRefreshCounter}
                    users={users}
                />
            }
            {radioValue === 'meetings-midweek-av-ushers' &&
                <NotificationsMeetingsMidweekAvUshers
                    meetingsDoc={meetingsDoc}
                    notificationsDoc={notificationsDoc}
                    setRefreshCounter={setRefreshCounter}
                    users={users}
                />
            }
            {radioValue === 'meetings-midweek-cleaning' &&
                <NotificationsMeetingsMidweekCleaning
                    meetingsDoc={meetingsDoc}
                    notificationsDoc={notificationsDoc}
                    setRefreshCounter={setRefreshCounter}
                    users={users}
                />
            }
        </div>
    );
}
